export const updateJobsPath = (jobId) => {
  const updatePath = `/api/jobs/${jobId}`;

  return updatePath;
};

export const notifyOfPartialJobPath = () =>
  "/api/partial_submission_notifiers/new_jobs";
